import React from 'react';
import { Skeleton as MuiSkeleton } from '@mui/material';
import { styled } from '@mui/material/styles';

/**
 * Base Skeleton wrapper with Terappy shimmer animation
 * 
 * Enhanced MUI Skeleton with custom shimmer colors matching brand
 * Uses subtle verde lima hint for premium feel
 * 
 * Props: Same as MUI Skeleton + custom variants
 * - variant: 'text' | 'rectangular' | 'circular'
 * - width: string | number
 * - height: string | number
 * - animation: 'pulse' | 'wave' | false
 * 
 * @version 1.0.0 (Feb 2026)
 */

const StyledSkeleton = styled(MuiSkeleton)(({ theme }) => ({
  backgroundColor: '#FAFAFA',
  '&::after': {
    background: `linear-gradient(
      90deg,
      transparent,
      rgba(179, 204, 29, 0.08),
      transparent
    )`,
  },
}));

const Skeleton = ({ children, ...props }) => {
  return <StyledSkeleton {...props}>{children}</StyledSkeleton>;
};

export default Skeleton;
